import React, { useEffect, useState } from "react";
import {
  BtnBuscar,
  BtnAnterior,
  BtnSiguiente,
  BtnEliminar,
  BtnModificar,
  BtnAgregar,
  MenuCantidad,
} from "componentes/templates/btn_crud";
import { Cargando } from "componentes/templates/cargando";
import { GET , DELETE } from 'helpers/request'
import LanguageHelper from 'helpers/language_helper'

const Indicators = () => {

  const [listado, setListado] = useState(false);
  const [page, setPage] = useState(0);
  const [cantidad, setCantidad] = useState(5);
  const [key, setKeywords] = useState("");
  const [cargando, setCargando] = useState(true);
  const [total, setTotal] = useState(0);
  const len = sessionStorage.getItem('languageId');
  const [url, setUrl] = useState(
    `indicators/indicators?l=${cantidad}&o=${page}&k=${key}&le=${len}`
  );

  const [actualizar, setActualizar] = useState(false);

  const gestionarAnterior = () => {
    let desde = (page - 1) * cantidad;
    if (desde >= 0) {
      setPage(page - 1);
      setUrl(
        `indicators/indicators?l=${cantidad}&o=${desde}&k=${key}&le=${len}`
      );
    }
  };

  const gestionarCantidad = (event) => {
    event.preventDefault();
    setCantidad(event.target.value);
    setUrl(
      `indicators/indicators?l=${event.target.value}&o=${page}&k=${key}&le=${len}`
    );
  };


  const gestionarSiguiente = () => {
    let desde = (page + 1) * cantidad;
    if (desde < total) {
      setPage(page + 1);
      setUrl(
        `indicators/indicators?l=${cantidad}&o=${desde}&k=${key}&le=${len}`
      );
    }
  };

  const gestionarBuscar = (event) => {
    event.preventDefault();
    setPage(0);
    setUrl(
      `indicators/indicators?l=${cantidad}&o=${page}&k=${key}&le=${len}`
    );
  };

  const obtenerFiltro = (event) => {
    setKeywords(event.target.value);
  };

  const prepararListado = (result) => {
    var resultados = result;

    var indicators = resultados.datos;
    setTotal(resultados.total);

    const gestionarEliminar = async (id) => {

      try {
        await DELETE("indicators/indicators/",id);
        // console.log(res);
        setActualizar(true);
        
      } catch (error) {
        console.log("error ELIMINAR", error)
      }

     
    };

    const listaItems = indicators.map((item) => {
      return (
        <tr key={"ind_" + item.ind_int_id}>
          <td>{item.the_txt_name}</td>
          <td>{item.sth_txt_name}</td>
          <td>
            {item.tra_txt_translation}
          </td>
          <td>{item.ind_txt_code}</td>
          <td>
          <BtnModificar className="is-spaced" id={item.ind_int_id} nameE={"intranetIndicators/indicatorsList"} />
          <BtnEliminar gestionarEliminar={() => gestionarEliminar(item.ind_int_id)} />
          </td>
        </tr>
      );
    });
    setCargando(false);
    setListado(listaItems);
  };

  useEffect(() => {
    const fetcher = async () => {
      const list = await GET(url);
      list.error ? console.log("error useEffect ", list.error) : prepararListado(list);

      setActualizar(false);


      return () => {
        setCargando(true);
      };
    };
    fetcher();
    
  }, [url, actualizar]);


  if (cargando) return <Cargando />;
  else
return (

  <>
<div className="columns">
<div className="column is-11 is-offset-1">
  <h1 className="title is-1">{LanguageHelper.getLanguageString('Indicators.Title')}</h1>
</div>
</div>

<div className="columns">
          <div className="column is-8 is-offset-1">
            <form onSubmit={gestionarBuscar}>
              <div className="field has-addons">
                <div className="control has-icons-left has-icons-right">
                  <input
                    className="input"
                    type="text"
                    name="k"
                    id="k"
                    placeholder={LanguageHelper.getLanguageString('Indicators.placeholder')}
                    onChange={obtenerFiltro}
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-search"></i>
                  </span>
                </div>
                <div className="control">
                  <BtnBuscar />
                </div>
              </div>
            </form>
          </div>
          <div className="column is-2">
            <BtnAgregar nameE={"intranetIndicators/indicatorsList"}>{LanguageHelper.getLanguageString('Indicators.add')}</BtnAgregar>
          </div>
        </div>

        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div className="table-container">
              <table className="table is-striped is-bordered is-hoverable is-fullwidth">
                <thead>
                  <tr>
                    
                    <th>{LanguageHelper.getLanguageString('Indicators.thematic')}</th>
                    <th>{LanguageHelper.getLanguageString('Indicators.subthematic')}</th>
                    <th>{LanguageHelper.getLanguageString('Indicators.name')}</th>
                    <th>{LanguageHelper.getLanguageString('Indicators.code')}</th>
                    <th>{LanguageHelper.getLanguageString('Indicators.options')}</th>
                  </tr>
                </thead>
                <tbody>{listado}</tbody>
                <tfoot>
                  <tr>
                    <td colSpan="3" className="has-text-centered">
                      {page > 0 ? (
                        <BtnAnterior gestionarAnterior={gestionarAnterior} />
                      ) : (
                          <BtnAnterior gestionarAnterior={null} />
                        )}

                      <MenuCantidad
                        className=""
                        gestionarCantidad={gestionarCantidad}
                        total={total}
                        can={cantidad}
                      />

                      {(page + 1) * cantidad < total ? (
                        <BtnSiguiente gestionarSiguiente={gestionarSiguiente} />
                      ) : (
                          <BtnSiguiente gestionarSiguiente={null} />
                        )}
                    </td>
                    <td>{LanguageHelper.getLanguageString('Indicators.total')}: {total}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

</>
);
};
export default Indicators;